function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Input as InputSemantic } from 'semantic-ui-react';
import { Label, Segment, Ref } from "../..";
import FormField from "../Form/FormField";
import { getRest } from "../../utils";

/**
 * Champ de saisie avec state.
 *
 * @class Input
 * @extends {React.PureComponent}
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var InputCounter = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(InputCounter, _React$PureComponent);
  function InputCounter(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    /**
       * Gestion des modifications.
       *
       * @memberof Input
       */
    _this.handleChange = function (event, data) {
      var target = event.target;
      var value = target.value;
      _this.setState({
        characterCount: _.size(value),
        value: value
      });
      _.invoke(_this.props, 'onChange', event, data);
    };
    /**
       * Handle reference width of label.
       *
       * @memberof InputCounter
       */
    _this.handleRef = function (node) {
      var resizeObserver = new ResizeObserver(function (entries) {
        _.map(entries, function (entry) {
          if (entry.contentRect) {
            _this.setState({
              fieldWidth: entry.contentRect.width
            });
          }
        });
      });
      if (!_.isNil(node)) {
        resizeObserver.observe(node);
      }
    };
    /**
       *
       * @memberof InputCounter
       */
    _this.renderCaracteresRestant = function () {
      var maxLength = _this.props.maxLength;
      var _this$state = _this.state,
        fieldWidth = _this$state.fieldWidth,
        characterCount = _this$state.characterCount,
        focused = _this$state.focused;
      var characterRemaining = maxLength - characterCount;
      var libelleRestant = characterRemaining > 1 ? "Caract\xE8res restants : " + characterRemaining : "Caract\xE8re restant : " + characterRemaining;
      return /*#__PURE__*/_jsx(Label, {
        horizontal: true,
        size: "mini",
        color: "grey",
        style: {
          position: 'absolute',
          right: 0,
          marginRight: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          opacity: 0.55,
          letterSpacing: 1
        },
        children: focused ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [fieldWidth < 90 && characterRemaining + " / " + maxLength, fieldWidth >= 90 && fieldWidth <= 175 && "Reste : " + characterRemaining, (fieldWidth > 175 || _.isNil(fieldWidth)) && libelleRestant]
        }) : characterRemaining + "/" + maxLength
      });
    };
    /**
       * Display the character counter
       *
       * @memberof InputCounter
      */
    _this.handleFocus = function (event, data) {
      var onFocus = _this.props.onFocus;
      _this.setState({
        focused: true
      });
      if (onFocus) {
        onFocus(event, data);
      }
    };
    /**
       * Hide the character counter
       *
       * @memberof InputCounter
      */
    _this.handleBlur = function (event, data) {
      var onBlur = _this.props.onBlur;
      _this.setState({
        focused: false
      });
      if (onBlur) {
        onBlur(event, data);
      }
    };
    var _value = props.value;
    _this.state = {
      characterCount: !_.isNil(_value) ? _value.length : 0,
      value: _value,
      prevValue: _value,
      fieldWidth: null,
      focused: false
    };
    return _this;
  }

  /**
     * @description
     *
     * @static
     * @memberof Input
     */
  InputCounter.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, previousState) {
    var prevValue = previousState.prevValue;

    // Compare the incoming prop to previous prop
    var value = prevValue !== nextProps.value ? nextProps.value : previousState.value;
    return {
      // Store the previous props in state
      prevValue: nextProps.value,
      value: value,
      characterCount: !_.isNil(value) ? value.length : 0
    };
  };
  var _proto = InputCounter.prototype;
  /**
     * Render with Character count.
     *
     * @memberof Input
     */
  _proto.render = function render() {
    var _this$props = this.props,
      name = _this$props.name,
      label = _this$props.label,
      icon = _this$props.icon,
      width = _this$props.width,
      placeholder = _this$props.placeholder,
      required = _this$props.required,
      maxLength = _this$props.maxLength;
    var _this$state2 = this.state,
      value = _this$state2.value,
      focused = _this$state2.focused,
      characterCount = _this$state2.characterCount;
    var rest = getRest(InputCounter, this.props);
    var inputProps = {
      key: name,
      name: name,
      placeholder: placeholder,
      value: value,
      icon: icon,
      width: width,
      onChange: this.handleChange
    };
    return /*#__PURE__*/_jsxs(Segment, {
      basic: true,
      style: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        margin: 0
      },
      children: [/*#__PURE__*/_jsx(Ref, {
        innerRef: this.handleRef,
        children: /*#__PURE__*/_jsxs(FormField, {
          required: required,
          style: {
            marginBottom: 0
          },
          children: [/*#__PURE__*/_jsx("label", {
            children: label
          }), " ", /*#__PURE__*/_jsx(InputSemantic, Object.assign({
            input: {
              style: {
                borderBottomRightRadius: 0
              }
            }
          }, rest, inputProps, {
            maxLength: maxLength,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
          }))]
        })
      }), !_.isNil(maxLength) && (focused || characterCount !== 0) && this.renderCaracteresRestant()]
    });
  };
  return InputCounter;
}(React.PureComponent);
InputCounter.handledProps = ["icon", "label", "maxLength", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "value", "width"];
InputCounter.propTypes = {
  /** Valeur */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Nom */
  name: PropTypes.string,
  /** Label */
  label: PropTypes.string,
  /** Icone */
  icon: PropTypes.string,
  /** Largeur */
  width: PropTypes.number,
  /** Placeholder */
  placeholder: PropTypes.string,
  /** Required. */
  required: PropTypes.bool,
  /** Callback on change. Discouraged use for value's update. */
  onChange: PropTypes.func,
  /** Callback on blur. */
  onBlur: PropTypes.func,
  /** Callback on focus. */
  onFocus: PropTypes.func,
  /** Nombre de caractères maximum du champ */
  maxLength: PropTypes.number.isRequired
};
InputCounter.defaultProps = {
  value: ''
};
export default InputCounter;